"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateReceivableBorrowingBaseReport = exports.calculateBorrowingBaseReport = exports.generateBorrowingBaseInsightCalcs = exports.calculateBorrowingBaseAvailabilityAttributes = exports.calculateBorrowingBaseKeyCashAttributes = exports.calculateTotalEligibleBorrowingBaseAccountCash = exports.calculateEffectiveCashAdvanceRate = exports.calcMaxCashAdvanceAmount = exports.calcBorrowingBaseCash = exports.calcEffectiveReceivableValuationRate = exports.calcWeightedAverageReceivableAdvanceRate = exports.calcEffectiveReceivableAdvanceRate = exports.createBasicBorrowingBaseReportWithCalcs = exports.createBasicBorrowingBaseReport = exports.createEligibilityCriteriaCalculationsFromLoanTapeWithCalcs = exports.createEligibilityCriteriaCalculationsFromBorrowingBaseReceivables = exports.creditFacilityToBorrowingBaseReceivables = exports.creditFacilityToBorrowingBaseReceivablesUsingMechanics = void 0;
const _ = __importStar(require("lodash"));
const remeda_1 = require("remeda");
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const calcAgentMechanics_1 = require("./calcAgentMechanics");
const classDetailsMechanics_1 = require("./classDetailsMechanics");
const convertToConcentrationLimitReceivables_1 = require("./convertToConcentrationLimitReceivables");
const progressHelper_1 = require("./progressHelper");
const { flatMap } = _;
const creditFacilityToBorrowingBaseReceivablesUsingMechanics = async ({ calcAgentMechanics, creditFacilityReceivables, progressCallback, receivableWaivers, }) => {
    const [eligibilityProgress, concentrationProgress, advanceRateProgress,] = (0, progressHelper_1.createPartialProgressCallbacks)({
        progressCallback,
        weights: [45, 45, 10],
    });
    // Run valuation and eligibility tests while creating concentration limit receivables
    const concentrationLimitReceivables = await (0, convertToConcentrationLimitReceivables_1.convertToConcentrationLimitReceivables)({
        creditFacilityReceivables,
        calcAgentMechanics,
        progressCallback: eligibilityProgress,
        receivableWaivers,
    });
    // Run concentration limits evaluation, mutates concentrationLimitReceivables
    const concentrationLimitCalculations = await calcAgentMechanics.evaluateConcentrationAndMutateReceivables({
        concentrationLimitReceivables,
        progressCallback: concentrationProgress,
        receivableWaivers,
    });
    // Run Advance Rate evaluation
    const borrowingBaseReceivables = await calcAgentMechanics.evaluateAdvanceRate({
        concentrationLimitReceivables,
        progressCallback: advanceRateProgress,
    });
    // Compute borrowing base
    let maxReceivableAdvanceAmount = 0;
    let borrowingBaseAmountAssets = 0;
    let totalEligibleExposure = 0;
    let totalReceivableExposure = 0;
    borrowingBaseReceivables.forEach((borrowingBaseReceivable) => {
        maxReceivableAdvanceAmount +=
            borrowingBaseReceivable.borrowingBaseFields.borrowingBaseAmount;
        borrowingBaseAmountAssets +=
            borrowingBaseReceivable.concentrationLimitFields
                .eligibleExposureLessConcentrationLimitKickouts;
        totalEligibleExposure +=
            borrowingBaseReceivable.eligibilityFields.eligibleExposure;
        totalReceivableExposure +=
            borrowingBaseReceivable.requiredIntermediateFields.exposure;
    });
    return {
        maxReceivableAdvanceAmount,
        borrowingBaseAmountAssets,
        totalEligibleExposure,
        totalReceivableExposure,
        borrowingBaseReceivables,
        concentrationLimitCalculations,
    };
};
exports.creditFacilityToBorrowingBaseReceivablesUsingMechanics = creditFacilityToBorrowingBaseReceivablesUsingMechanics;
const creditFacilityToBorrowingBaseReceivables = async ({ loanTapeMetadata, creditFacilityReceivables, borrowingBaseMechanics, progressCallback, receivableWaivers, f1EngineMode, }) => {
    const calcAgentMechanics = (0, calcAgentMechanics_1.createCalcAgentMechanics)({
        config: borrowingBaseMechanics,
        loanTapeMetadata,
        f1EngineMode,
    });
    return (0, exports.creditFacilityToBorrowingBaseReceivablesUsingMechanics)({
        calcAgentMechanics,
        creditFacilityReceivables,
        progressCallback,
        receivableWaivers,
    });
};
exports.creditFacilityToBorrowingBaseReceivables = creditFacilityToBorrowingBaseReceivables;
const createEligibilityCriteriaCalculations = ({ eligibilityKickouts, eligibilityTestConfigs, }) => {
    const calculationsMap = new Map(eligibilityTestConfigs.map((config) => [
        config.propertyKey,
        {
            eligibilityCriteriaKey: config.propertyKey,
            eligibilityReduction: 0,
        },
    ]));
    // iterate through every eligibility criteria to track this receivable's total ineligibility contributionInEligible
    eligibilityKickouts.forEach(({ eligibilityCriteriaKey, eligibilityStatus, kickout }) => {
        const eligibilityCalculation = calculationsMap.get(eligibilityCriteriaKey);
        (0, common_1.finleyAssert)(eligibilityCalculation, `Expected for eligibility criteria ${eligibilityCriteriaKey} found in receivableJSON to exist in top-level eligibility criteria set`);
        // we will track kickout for every eligibility criteria
        // that this receivable is ineligible for
        if (eligibilityStatus === 'INELIGIBLE') {
            eligibilityCalculation.eligibilityReduction += kickout;
        }
    });
    return Array.from(calculationsMap.values());
};
const createEligibilityCriteriaCalculationsFromBorrowingBaseReceivables = ({ receivables, eligibilityTestConfigs, }) => {
    const eligibilityKickouts = flatMap(receivables, (receivable) => {
        // if a receivable is ineligible for anything, it's kickout amount
        // will exist in this property
        const kickout = receivable.eligibilityFields.eligibilityKickout;
        return (0, remeda_1.map)(receivable.eligibilityStatuses, ({ eligibilityCriteriaKey, eligibilityStatus }) => ({
            eligibilityCriteriaKey,
            eligibilityStatus,
            kickout,
        }));
    });
    return createEligibilityCriteriaCalculations({
        eligibilityKickouts,
        eligibilityTestConfigs,
    });
};
exports.createEligibilityCriteriaCalculationsFromBorrowingBaseReceivables = createEligibilityCriteriaCalculationsFromBorrowingBaseReceivables;
const createEligibilityCriteriaCalculationsFromLoanTapeWithCalcs = ({ borrowingBaseReceivables, eligibilityTestConfigs, }) => {
    const eligibilityKickouts = flatMap(borrowingBaseReceivables, (record) => {
        return (0, remeda_1.map)(record.eligibilityStatuses, ({ eligibilityCriteriaKey, eligibilityStatus }) => ({
            eligibilityCriteriaKey,
            eligibilityStatus,
            kickout: record.eligibilityFields.eligibilityKickout, // this is a confusing, since this kickout doesn't necessary apply to this key, but next method createEligibilityCriteriaCalculations handles appropriately
        }));
    });
    return createEligibilityCriteriaCalculations({
        eligibilityKickouts,
        eligibilityTestConfigs,
    });
};
exports.createEligibilityCriteriaCalculationsFromLoanTapeWithCalcs = createEligibilityCriteriaCalculationsFromLoanTapeWithCalcs;
const createBasicBorrowingBaseReport = async ({ receivables, progressCallback, borrowingBaseReportForLatestApprovedFundingRequestMetadata, }) => {
    const borrowingBaseReportId = (0, uuid_1.v4)();
    let totalReceivableExposure = 0;
    let borrowingBaseAmountAssets = 0;
    let totalEligibleExposure = 0;
    let maxReceivableAdvanceAmount = 0;
    let assignedEligibleExposureSinceLastApprovedFundingRequest = 0;
    const { updateProgress } = (0, progressHelper_1.createProgressHelper)({
        operation: 'Create basic borrowing base report',
        progressCallback,
        numRows: receivables.length,
    });
    // eslint-disable-next-line no-restricted-syntax, no-plusplus, finley/variable-length
    for (let index = 0; index < receivables.length; index++) {
        const receivable = receivables[index];
        // eslint-disable-next-line no-await-in-loop
        await updateProgress(index);
        totalReceivableExposure += receivable.requiredIntermediateFields.exposure;
        totalEligibleExposure += receivable.eligibilityFields.eligibleExposure;
        // NOTE: this is confusing, so bear in there until we can refactor properly
        // legacy borrowingBaseAmountAssets === eligibleExposureLessConcentrationKickouts in new domain
        // legacy maxReceivableAdvanceAmount === borrowingBaseAmount in new domain
        borrowingBaseAmountAssets +=
            receivable.concentrationLimitFields
                .eligibleExposureLessConcentrationLimitKickouts;
        maxReceivableAdvanceAmount +=
            receivable.borrowingBaseFields.borrowingBaseAmount;
        // all receivables should be assigned
        if (receivable.assignmentFields) {
            if (!borrowingBaseReportForLatestApprovedFundingRequestMetadata ||
                receivable.assignmentFields.reportingDate >
                    borrowingBaseReportForLatestApprovedFundingRequestMetadata.reportingDate ||
                (receivable.assignmentFields.reportingDate ===
                    borrowingBaseReportForLatestApprovedFundingRequestMetadata.reportingDate &&
                    receivable.assignmentFields.fileVersion >
                        borrowingBaseReportForLatestApprovedFundingRequestMetadata.fileVersion)) {
                assignedEligibleExposureSinceLastApprovedFundingRequest +=
                    receivable.eligibilityFields.eligibleExposure;
            }
        }
    }
    const totalEligibilityKickout = totalReceivableExposure - totalEligibleExposure;
    const totalConcentrationKickout = totalEligibleExposure - borrowingBaseAmountAssets;
    return {
        id: borrowingBaseReportId,
        maxReceivableAdvanceAmount, // the eligibleExposureLessConcentrationKickouts * effectiveReceivableAdvanceRate
        borrowingBaseAmountAssets, // Total borrowing base of receivables, aka eligibleExposureLessConcentrationKickouts
        totalEligibleExposure, // Total eligible exposure of receivables
        totalReceivableExposure, // Total exposure of receivables
        totalEligibilityKickout, // total eligibility kickout
        totalConcentrationKickout, /// total concentration kickout
        assignedEligibleExposureSinceLastApprovedFundingRequest, // newly assigned eligible exposure since last submitted funding request
    };
};
exports.createBasicBorrowingBaseReport = createBasicBorrowingBaseReport;
// derives partial report from the loanTapeWithCalcs
const createBasicBorrowingBaseReportWithCalcs = async ({ borrowingBaseMechanics, concentrationLimitCalculations, borrowingBaseReceivables, progressCallback, }) => {
    const [creatingBasicBBRProgress, mappingEligibilityProgress,] = (0, progressHelper_1.createPartialProgressCallbacks)({
        progressCallback,
        weights: [70, 30],
    });
    const basicBorrowingBaseReport = await (0, exports.createBasicBorrowingBaseReport)({
        receivables: borrowingBaseReceivables,
        progressCallback: creatingBasicBBRProgress,
    });
    // TODO: this only needs to be a simple map reduce type method
    // let's simplify in next pass
    const eligibilityCriteriaCalculationsPreMap = (0, exports.createEligibilityCriteriaCalculationsFromLoanTapeWithCalcs)({
        borrowingBaseReceivables,
        eligibilityTestConfigs: flatMap(borrowingBaseMechanics.loanProducts, (lp) => lp.eligibilityTestConfigs),
    });
    const { updateProgress: mappingEligibilityProgressUpdate, } = (0, progressHelper_1.createProgressHelper)({
        progressCallback: mappingEligibilityProgress,
        operation: 'Map Eligibility',
        numRows: eligibilityCriteriaCalculationsPreMap.length,
    });
    const eligibilityCriteriaCalculations = await Promise.all(eligibilityCriteriaCalculationsPreMap.map(async (calculations, index) => {
        await mappingEligibilityProgressUpdate(index);
        return {
            ...calculations,
            id: (0, uuid_1.v4)(),
            borrowingBaseReportId: basicBorrowingBaseReport.id,
            created_at: new Date(),
            updated_at: new Date(),
        };
    }));
    return {
        basicBorrowingBaseReport,
        concentrationLimitCalculations: (0, remeda_1.map)(concentrationLimitCalculations, (calc) => ({
            ...calc,
            id: (0, uuid_1.v4)(),
            borrowingBaseReportId: basicBorrowingBaseReport.id,
            created_at: new Date(),
            updated_at: new Date(),
        })),
        eligibilityCriteriaCalculations,
    };
};
exports.createBasicBorrowingBaseReportWithCalcs = createBasicBorrowingBaseReportWithCalcs;
const calcEffectiveReceivableAdvanceRate = ({ totalReceivableBorrowingBaseAmount, totalReceivableExposure, }) => {
    return common_1.utils.divideByOrZero(totalReceivableBorrowingBaseAmount, totalReceivableExposure);
};
exports.calcEffectiveReceivableAdvanceRate = calcEffectiveReceivableAdvanceRate;
const calcWeightedAverageReceivableAdvanceRate = ({ totalReceivableBorrowingBaseAmount, totalEligibleExposureLessConcentrationKickouts, }) => {
    return common_1.utils.divideByOrZero(totalReceivableBorrowingBaseAmount, totalEligibleExposureLessConcentrationKickouts);
};
exports.calcWeightedAverageReceivableAdvanceRate = calcWeightedAverageReceivableAdvanceRate;
const calcEffectiveReceivableValuationRate = ({ assetValuation, totalReceivableExposure, }) => {
    return common_1.utils.divideByOrZero(assetValuation, totalReceivableExposure);
};
exports.calcEffectiveReceivableValuationRate = calcEffectiveReceivableValuationRate;
const calcBorrowingBaseCash = (bankAccountCashBalances) => {
    return bankAccountCashBalances.reduce((accCash, ba) => {
        const currCash = common_1.typeguards.isBorrowingBaseContributionAccountType(ba.accountType) &&
            ba.balance
            ? ba.balance
            : 0;
        return accCash + currCash;
    }, 0);
};
exports.calcBorrowingBaseCash = calcBorrowingBaseCash;
const calcMaxCashAdvanceAmount = (bankAccountCashBalances) => {
    return bankAccountCashBalances.reduce((accCash, ba) => {
        const currCash = common_1.typeguards.isBorrowingBaseContributionAccountType(ba.accountType) &&
            ba.balance &&
            ba.cashAdvanceRate
            ? ba.balance * ba.cashAdvanceRate
            : 0;
        return accCash + currCash;
    }, 0);
};
exports.calcMaxCashAdvanceAmount = calcMaxCashAdvanceAmount;
// TODO chris update commonUtils.calculateWeightedAverage to remove rounding
const calculateWeightedAverage = (dataArray) => {
    let numerator = 0;
    let denominator = 0;
    for (const { value, weight } of dataArray) {
        numerator += value * weight;
        denominator += weight;
    }
    return common_1.utils.divideByOrZero(numerator, denominator);
};
const calculateEffectiveCashAdvanceRate = (bankAccountCashBalances) => {
    const contributingAccounts = bankAccountCashBalances.filter((ba) => common_1.typeguards.isBorrowingBaseContributionAccountType(ba.accountType));
    const bankAccountsData = contributingAccounts.map((ba) => {
        (0, common_1.finleyAssert)(!_.isNil(ba.cashAdvanceRate) && !_.isNaN(ba.cashAdvanceRate), new common_1.error.FinleyError('Contributing accounts mush have a valid cashAdvanceRate', { metadata: { logMeta: bankAccountCashBalances } }));
        return {
            value: ba.cashAdvanceRate,
            weight: ba.balance,
        };
    });
    const effectiveCashAdvanceRate = calculateWeightedAverage(bankAccountsData);
    return effectiveCashAdvanceRate;
};
exports.calculateEffectiveCashAdvanceRate = calculateEffectiveCashAdvanceRate;
const calculateTotalEligibleBorrowingBaseAccountCash = (bankAccountCashBalances) => {
    const totalEligibleBorrowingBaseAccountCash = bankAccountCashBalances.reduce((total, cashAccount) => {
        const { accountType, balance } = cashAccount;
        if (!common_1.typeguards.isBorrowingBaseContributionAccountType(accountType)) {
            return total;
        }
        return total + balance;
    }, 0);
    return totalEligibleBorrowingBaseAccountCash;
};
exports.calculateTotalEligibleBorrowingBaseAccountCash = calculateTotalEligibleBorrowingBaseAccountCash;
const calculateBorrowingBaseKeyCashAttributes = (bankAccountCashBalances, cashAdjustments) => {
    const { isBorrowingBaseReservePositiveExcessCollectionsOverReserve, } = cashAdjustments;
    const borrowingBaseReserveAmount = cashAdjustments.borrowingBaseReserveAmount ?? 0;
    const collectionAccounts = bankAccountCashBalances.filter((ba) => ba.accountType === finley_types_1.Bank.BorrowerAccountType.Collections);
    // Retrieve collections amount for later borrowingBaseReserveAmount adjustments
    const totalCollectionsAccountCash = collectionAccounts.reduce((total, ca) => total + ca.balance, 0);
    const reserveAdjustedCollectionsCash = isBorrowingBaseReservePositiveExcessCollectionsOverReserve
        ? Math.max(totalCollectionsAccountCash - borrowingBaseReserveAmount, 0)
        : totalCollectionsAccountCash - borrowingBaseReserveAmount;
    let totalCollectionsCashBorrowingBaseAmount = 0;
    if (reserveAdjustedCollectionsCash < 0) {
        totalCollectionsCashBorrowingBaseAmount = reserveAdjustedCollectionsCash;
    }
    else {
        // Calculate collections cash amount that contributes to borrowing base
        // we use conservative approach (one that leads to smallest amount) here,
        // for this we use highest advance rate accounts against reserver first, leaving
        // lowest advance rate accounts to use for totalCollectionsCashBorrowingBaseAmount.
        let remainingCashReserve = borrowingBaseReserveAmount;
        collectionAccounts
            .sort((a, b) => {
            // sort collection accounts by advanceRate, highest first
            return (b.cashAdvanceRate || 0) - (a.cashAdvanceRate || 0);
        })
            .forEach((ca) => {
            const { balance, cashAdvanceRate } = ca;
            const cashReserve = Math.min(balance, remainingCashReserve);
            remainingCashReserve -= cashReserve;
            const balanceAfterReserve = balance - cashReserve;
            const postReservePostAdvanceBalance = balanceAfterReserve * (cashAdvanceRate ?? 0);
            totalCollectionsCashBorrowingBaseAmount += postReservePostAdvanceBalance;
        });
    }
    // Retrieving cash amounts that contribute to borrowing base besides collections account
    const otherCashAccounts = bankAccountCashBalances.filter((ba) => common_1.typeguards.isBorrowingBaseContributionAccountType(ba.accountType) &&
        ba.accountType !== finley_types_1.Bank.BorrowerAccountType.Collections);
    const totalOtherAccountCash = otherCashAccounts.reduce((total, cashAccount) => total + cashAccount.balance, 0);
    const totalOtherCashBorrowingBaseAmount = otherCashAccounts.reduce((total, cashAccount) => {
        const { balance, cashAdvanceRate } = cashAccount;
        return total + balance * (cashAdvanceRate ?? 0);
    }, 0);
    // 1: Total eligible cash amounts in borrowing base accounts
    const totalEligibleBorrowingBaseAccountCash = totalOtherAccountCash + totalCollectionsAccountCash;
    // 2: Reducing eligible cash amounts (1) by borrowing base reserve amount, depending on collections account
    const totalPreAdvanceCashContribution = totalOtherAccountCash + reserveAdjustedCollectionsCash;
    const totalCashBorrowingBaseAmount = totalOtherCashBorrowingBaseAmount + totalCollectionsCashBorrowingBaseAmount;
    // 4: Calculate effective (weighted average) advance rate (3 / 2)
    const effectiveCashAdvanceRate = common_1.utils.divideByOrZero(totalCashBorrowingBaseAmount, totalPreAdvanceCashContribution);
    return {
        totalEligibleBorrowingBaseAccountCash,
        totalCollectionsAccountCash,
        totalPreAdvanceCashContribution,
        totalCashBorrowingBaseAmount,
        effectiveCashAdvanceRate,
    };
};
exports.calculateBorrowingBaseKeyCashAttributes = calculateBorrowingBaseKeyCashAttributes;
/**
 * Lesser value between (totalBorrowingBaseAmount OR commitmentAmount), minus currentPrincipalBalance
 * A negative value will imply a deficiency in borrowing base availability
 */
const calculateBorrowingBaseAvailabilityAttributes = ({ totalReceivableBorrowingBaseAmount, totalCashBorrowingBaseAmount, commitmentAmount, currentPrincipalBalance, }) => {
    // @dani will no longer need to derive totalBorrowingBaseAmount after phase 3 borrowing base migration
    const totalBorrowingBaseAmountDerived = (totalReceivableBorrowingBaseAmount ?? 0) +
        (totalCashBorrowingBaseAmount ?? 0);
    const maximumAvailableAmount = Math.min(commitmentAmount, totalBorrowingBaseAmountDerived);
    // Lesser value between (totalBorrowingBaseAmount OR commitmentAmount), minus currentPrincipalBalance
    // A negative value will imply a deficiency in borrowing base availability
    const borrowingBaseAvailability = maximumAvailableAmount - currentPrincipalBalance;
    const borrowingBaseAvailabilityRate = common_1.utils.divideByOrZero(borrowingBaseAvailability, maximumAvailableAmount);
    return {
        maximumAvailableAmount,
        borrowingBaseAvailability,
        borrowingBaseAvailabilityRate,
    };
};
exports.calculateBorrowingBaseAvailabilityAttributes = calculateBorrowingBaseAvailabilityAttributes;
const generateBorrowingBaseInsightCalcs = ({ bankAccountCashBalances, currentPrincipalBalance, assetValuation, borrowingBaseAmountAssets, maxReceivableAdvanceAmount, commitmentAmount, settlementDate, totalReceivableExposure, }) => {
    const totalCash = (0, exports.calcBorrowingBaseCash)(bankAccountCashBalances);
    const maxCashAdvanceAmount = (0, exports.calcMaxCashAdvanceAmount)(bankAccountCashBalances);
    const totalMaxAdvanceAmount = maxReceivableAdvanceAmount + maxCashAdvanceAmount;
    const totalBorrowingBaseAmount = borrowingBaseAmountAssets + totalCash;
    const totalFacilityUtilization = common_1.utils.divideByOrZero(currentPrincipalBalance, commitmentAmount);
    const totalEligibleBorrowingBaseAccountCash = (0, exports.calculateTotalEligibleBorrowingBaseAccountCash)(bankAccountCashBalances);
    const totalAssets = totalReceivableExposure + totalEligibleBorrowingBaseAccountCash;
    const effectiveAdvanceRate = common_1.utils.divideByOrZero(totalBorrowingBaseAmount, totalAssets);
    const borrowingBaseUtilization = common_1.utils.divideByOrZero(currentPrincipalBalance, totalBorrowingBaseAmount);
    const effectiveReceivableAdvanceRate = (0, exports.calcEffectiveReceivableAdvanceRate)({
        totalReceivableBorrowingBaseAmount: maxReceivableAdvanceAmount, // maxReceivableAdvanceAmount will be migrated in phase 3
        totalReceivableExposure,
    });
    const weightedAverageReceivableAdvanceRate = (0, exports.calcWeightedAverageReceivableAdvanceRate)({
        totalReceivableBorrowingBaseAmount: maxReceivableAdvanceAmount, // maxReceivableAdvanceAmount will be migrated in phase 3
        totalEligibleExposureLessConcentrationKickouts: borrowingBaseAmountAssets,
    });
    return {
        settlementDate,
        totalMaxAdvanceAmount,
        totalBorrowingBaseAmount,
        totalCash,
        currentPrincipalBalance,
        assetValuation,
        maxCashAdvanceAmount,
        totalFacilityUtilization,
        effectiveAdvanceRate,
        totalEligibleBorrowingBaseAccountCash,
        totalAssets,
        borrowingBaseUtilization,
        effectiveReceivableAdvanceRate,
        weightedAverageReceivableAdvanceRate,
    };
};
exports.generateBorrowingBaseInsightCalcs = generateBorrowingBaseInsightCalcs;
/**
 * This internal utility helps create DB records for concentration_limit_multi_loan_product_calculations.
 * It largely is just restructuring prior organized data while creating borrowing base report
 */
const _createMultiLoanProductConcentrationLimitRecords = (params) => {
    const { concentrationLimitCalculations, mlpConcentrationKickoutByLpMap, borrowingBaseReportId, } = params;
    const now = new Date();
    const concentrationMlpCalculations = [];
    // Setting up map to help connect each MLP concentration to its respective DB aggregate counterpart (FK).
    // Recall that "concentration_limit_calculations" also houses MLP concentration, but in aggregate view.
    const propertyKeyToCalculationMap = new Map(concentrationLimitCalculations.map((x) => [x.concentrationLimitKey, x.id]));
    for (const kickoutMapEntry of mlpConcentrationKickoutByLpMap.entries()) {
        const [concentrationLimitKey, lpToKickoutMap] = kickoutMapEntry;
        const concentrationLimitCalculationId = propertyKeyToCalculationMap.get(concentrationLimitKey);
        (0, common_1.finleyAssert)(concentrationLimitCalculationId, `Failed to find concentration limit calculation ID in map [concentrationLimitKey:${concentrationLimitKey}]`);
        for (const [loanProductId, kickout] of lpToKickoutMap.entries()) {
            concentrationMlpCalculations.push({
                id: (0, uuid_1.v4)(),
                borrowingBaseReportId,
                concentrationLimitCalculationId,
                loanProductId,
                concentrationLimitKey,
                borrowingBaseReduction: kickout,
                created_at: now,
                updated_at: now,
            });
        }
    }
    return concentrationMlpCalculations;
};
const calculateBorrowingBaseReport = async ({ bankAccountCashBalances, settlementDate, currentPrincipalBalance, isBorrowingBaseReservePositiveExcessCollectionsOverReserve, creditFacilitySlug, creditFacilityId, creditAgreementId, creditAgreementVersion, creditAgreementClassDetails, borrowingBaseMechanics, commitmentAmount, receivableResponseTape, reportingDate, fileVersion, organizationId, f1EngineMode, borrowingBaseReportForLatestApprovedFundingRequestMetadata, }) => {
    const { concentrationLimitCalculations: _concentrationLimitCalculations, receivables, } = receivableResponseTape;
    // Setting up maps that will house required information for helping organize MLP concentration calculations
    // This will facilitate look up capabilities, particularly around what concentration limits are
    // multi-loan product and which loan product is associated with the limit
    const mlpConcentrationKickoutByLpMap = new Map();
    const mlpConcentrationToLoanProductIdsMap = new Map();
    for (const mlpConcentration of borrowingBaseMechanics.multiLoanProductConcentrationLimits) {
        const { loanProductIds, propertyKey } = mlpConcentration;
        mlpConcentrationKickoutByLpMap.set(propertyKey, new Map());
        mlpConcentrationToLoanProductIdsMap.set(propertyKey, new Set(loanProductIds));
    }
    let assetValuation = 0;
    for (const receivable of receivables) {
        const { valuationFields, concentrationLimitReasons } = receivable;
        // Sum up total asset valuation impact
        assetValuation += valuationFields.valuation;
        // *** Managing Creation of Base Data for MLP Concentration for DB ***
        // Evaluate each of the receivables concentration limits to assess which ones are MLP,
        // and if they are, add the kickout impact to the map for later reorganization + store to DB
        for (const concentrationLimit of concentrationLimitReasons) {
            const { concentrationLimitKickout, propertyKey } = concentrationLimit;
            // Just validating this concentration limit is a MLP one and the receivable's LP id
            // is one of the ones affected by this MLP concentration limit
            const targetLoanIds = mlpConcentrationToLoanProductIdsMap.get(propertyKey);
            if (!targetLoanIds?.has(receivable.loanProductId)) {
                continue;
            }
            const loanProductKickoutMap = mlpConcentrationKickoutByLpMap.get(propertyKey);
            (0, common_1.finleyAssert)(loanProductKickoutMap, `Failed to find MLP concentration limit in map [propertyKey:${propertyKey}] [receivableId:${receivable.finleyReceivableId}]`);
            // Store the kickout impact specifically to this loan product for the concentration limit
            const addedKickoutAmount = (loanProductKickoutMap.get(receivable.loanProductId) || 0) +
                concentrationLimitKickout;
            loanProductKickoutMap.set(receivable.loanProductId, addedKickoutAmount);
        }
    }
    const basicBorrowingBaseReport = await (0, exports.createBasicBorrowingBaseReport)({
        receivables,
        borrowingBaseReportForLatestApprovedFundingRequestMetadata: borrowingBaseReportForLatestApprovedFundingRequestMetadata ?? undefined,
    });
    const { id: borrowingBaseReportId, maxReceivableAdvanceAmount, borrowingBaseAmountAssets, totalReceivableExposure, } = basicBorrowingBaseReport;
    const eligibilityCriteriaCalculations = (0, exports.createEligibilityCriteriaCalculationsFromBorrowingBaseReceivables)({
        receivables,
        eligibilityTestConfigs: flatMap(borrowingBaseMechanics.loanProducts, (lp) => lp.eligibilityTestConfigs),
    }).map((calculations) => {
        return {
            ...calculations,
            id: (0, uuid_1.v4)(),
            borrowingBaseReportId,
            created_at: new Date(),
            updated_at: new Date(),
        };
    });
    const concentrationLimitCalculations = _concentrationLimitCalculations.map((calculations) => {
        return {
            ...calculations,
            id: (0, uuid_1.v4)(),
            borrowingBaseReportId,
            created_at: new Date(),
            updated_at: new Date(),
        };
    });
    const concentrationLimitMultiLoanProductCalculations = _createMultiLoanProductConcentrationLimitRecords({
        mlpConcentrationKickoutByLpMap,
        concentrationLimitCalculations,
        borrowingBaseReportId,
    });
    const cashAdvanceRate = (0, exports.calculateEffectiveCashAdvanceRate)(bankAccountCashBalances);
    const borrowingBaseInsights = (0, exports.generateBorrowingBaseInsightCalcs)({
        bankAccountCashBalances,
        assetValuation,
        maxReceivableAdvanceAmount,
        settlementDate,
        currentPrincipalBalance,
        borrowingBaseAmountAssets,
        commitmentAmount,
        reportingDate,
        totalReceivableExposure,
    });
    const effectiveReceivableValuationRate = (0, exports.calcEffectiveReceivableValuationRate)({
        assetValuation: borrowingBaseInsights.assetValuation,
        totalReceivableExposure: basicBorrowingBaseReport.totalReceivableExposure,
    });
    // *** Class Detail Mechanics ***
    const borrowingBaseClassDetails = {
        classAttachmentLimits: null,
    };
    if (creditAgreementClassDetails) {
        const classDetailMechanics = (0, classDetailsMechanics_1.createClassDetailMechanics)({
            classDetails: creditAgreementClassDetails,
            f1EngineMode,
        });
        const classDetailReceivables = receivables.map((receivable) => classDetailMechanics.sanitizeAttachmentReceivable({ receivable }));
        classDetailMechanics.initializeAttachmentRateLimitEvaluate({
            sanitizedReceivables: classDetailReceivables,
        });
        const classAttachmentLimits = (0, classDetailsMechanics_1.createClassAttachmentListsFromMechanics)({
            classDetailMechanics,
        });
        borrowingBaseClassDetails.classAttachmentLimits = classAttachmentLimits;
        // Done utilizing class mechanics engine, can tear down now
        classDetailMechanics.cleanUp();
    }
    const borrowingBaseReport = {
        ...basicBorrowingBaseReport,
        ...borrowingBaseInsights,
        borrowerId: organizationId,
        created_at: new Date(),
        creditAgreementVersion,
        creditFacilityId,
        creditAgreementId,
        creditFacilitySlug,
        fileVersion,
        reportingDate,
        updated_at: new Date(),
        cashAdvanceRate,
        commitmentAmount,
        isBorrowingBaseReservePositiveExcessCollectionsOverReserve,
        effectiveReceivableValuationRate,
        // these are updated later in insertBorrowingBaseReportAndCreateProgrammaticFundingRequest => updateReserveAmounts.
        cashReserveAmount: null,
        borrowingBaseReserveAmount: null,
        totalCollectionsAccountCash: null,
        totalPreAdvanceCashContribution: null,
        totalCashBorrowingBaseAmount: null,
        effectiveCashAdvanceRate: null,
        classDetails: borrowingBaseClassDetails,
    };
    return {
        borrowingBaseReport,
        eligibilityCriteriaCalculations,
        concentrationLimitCalculations,
        concentrationLimitMultiLoanProductCalculations,
    };
};
exports.calculateBorrowingBaseReport = calculateBorrowingBaseReport;
/**
 * Calculate a subset of borrowing base report metrics regarding receivables.
 * Intended to be used in cases where cash, eligibility details, and concentration limit details are not required.
 * For example, for borrowing_base_report_loan_product_calculations.
 */
const calculateReceivableBorrowingBaseReport = async ({ receivables, }) => {
    if (!receivables.length) {
        return null;
    }
    const assetValuation = _.sumBy(receivables, ({ valuationFields }) => valuationFields.valuation);
    const basicBorrowingBaseReport = await (0, exports.createBasicBorrowingBaseReport)({
        receivables,
    });
    const { totalReceivableExposure, totalEligibilityKickout, totalEligibleExposure, totalConcentrationKickout, borrowingBaseAmountAssets: totalEligibleExposureLessConcentrationKickouts, // will be migrated in phase 3
    maxReceivableAdvanceAmount: totalReceivableBorrowingBaseAmount, // will be migrated in phase 3
     } = basicBorrowingBaseReport;
    const effectiveReceivableValuationRate = (0, exports.calcEffectiveReceivableValuationRate)({ assetValuation, totalReceivableExposure });
    const weightedAverageReceivableAdvanceRate = (0, exports.calcWeightedAverageReceivableAdvanceRate)({
        totalReceivableBorrowingBaseAmount,
        totalEligibleExposureLessConcentrationKickouts,
    });
    const effectiveReceivableAdvanceRate = (0, exports.calcEffectiveReceivableAdvanceRate)({
        totalReceivableBorrowingBaseAmount,
        totalReceivableExposure,
    });
    const receivableBorrowingBaseReport = {
        totalReceivableExposure,
        totalEligibilityKickout,
        totalEligibleExposure,
        totalConcentrationKickout,
        totalEligibleExposureLessConcentrationKickouts,
        totalReceivableBorrowingBaseAmount,
        weightedAverageReceivableAdvanceRate,
        effectiveReceivableAdvanceRate,
        effectiveReceivableValuationRate,
    };
    return receivableBorrowingBaseReport;
};
exports.calculateReceivableBorrowingBaseReport = calculateReceivableBorrowingBaseReport;
//# sourceMappingURL=borrowingBase.js.map